import React from 'react'

const FlagPl = () => (
    <svg className="flag-pl" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">
        <path fill="#fff" d="M0 240h640v160H0z"/>
        <path fill="#dc143c" d="M0 240h640v160H0z"/>
    </svg>
)

export default FlagPl
